module.exports = {
  QueryBalance: '预付款客户查询',
  QueryDetail: '预付款明细查询',
  BalanceDetail: '余额变动明细',
  FinanceBalance: '业财余额',
  SendBalance: '发送名单',
  QuerySendBalanceState: '查询发送名单状态',
  InitializeBalance: '初始化余额',
  QuickSearchBalance: '快捷检索:客户编码',
  CustomerName: '客户名称',
  CustomerCode: '客户编码',
  SalesName: '销售',
  ParentBranchName: '上级机构名称',
  ParentBranchCode: '上级机构代码',
  BranchName: '归属部门名称',
  BranchCode: '归属部门编码',
  BranchId: '揽收机构',
  Balance: '余额',
  DateCreated: '创建日期',
  State: '名单同步状态',
  SubmittingAmount: '提交中金额',
  ShowChildData: '显示下级公司',
  ChangeAmount: '金额变动',
  ChangeType: '余额变动类型',
  LatestBalance: '最新余额',
  ChangeDate: '发生日期',
  Currency: '币种',
  JobNo: '业务编号',
  FinanceUpdateDate: '业财更新日期',
  SyncDate: '同步日期',
  CheckBalanceTitle: '预付款余额不足',
  CheckBalanceDetail: '{0}，[{1}]{2}：当前余额RMB {3}。提交中的业务已占用RMB {4}。本次提交RMB {5}',
  CheckBalanceDetail2: '[{0}]{1}：当前余额RMB {2}。提交中的业务已占用RMB {3}。本次提交RMB {4}',
  CustSettlement: '客户结算方式',
  InstCode: '网点编码',
  InstName: '网点名称',
  SrcSystem: '业务系统',
  AdvBalance: '当前预存款余额',
  OrderType: '业务类型',
  BlacklistRemark: '黑名单备注',
  AddedToBlacklist: '{0} 已加入黑名单',
  BalanceInitialized: '初始化余额之后，“预付款”客户 不可切换回 “计欠”',
  CustomerCodeDuplicate: '客户编码重复',
  NoMatchStateBySelected: '没有选中状态为[{0}]的记录',
  SendCustomerInfo: '发送名单',
  SendCustomerRemind: '*提醒：请确认客户所属部门编码和所属部门名称与业财系统资金认领机构编码和名称一致。如不一致，无法同步余额和充值信息。'
}
